<template>
	<el-container class="page-x" direction="vertical">
		<div class="search-x">
			<div class="search-item">
				<span class="label">服务类别</span>
				<el-cascader
					placeholder="请选择服务类别"
					clearable
					v-model="searchBox.serviceTypes"
					:options="serviceTypeList"
					:props="{
						value: 'id',
						label: 'name',
						emitPath: false,
						multiple: true,
						checkStrictly: true,
					}"
				></el-cascader>
			</div>
			<!-- <div class="search-item">
                <span class="label">服务项目</span>
                <select-all 
                    v-model="searchBox.ids"
                    :filterable="true"
                    :data="serviceList"
                    :option="{label: 'itemName', value: 'id'}">
                </select-all>
            </div> -->
			<div class="search-item">
				<span class="label">服务提供方</span>
				<select-all
					v-model="searchBox.providerIds"
					:data="supplierDataList"
					:option="{ label: 'providerName', value: 'id' }"
				>
				</select-all>
			</div>
			<div class="search-item">
				<span class="label">服务提供方式</span>
				<select-all
					v-model="searchBox.serviceModeIds"
					:data="serviceModeList"
					:option="{ label: 'name', value: 'id' }"
				>
				</select-all>
			</div>
			<div class="search-item">
				<span class="label">健康保险产品类别</span>
				<select-all
					v-model="searchBox.insuranceProductCategories"
					:data="optionsData"
					:option="{ label: 'label', value: 'value' }"
				>
				</select-all>
			</div>
			<div class="search-item">
				<span class="label">生成时间</span>
				<el-date-picker
					v-model="timeCache"
					@change="
						(e) =>
							toChangeTime(e, 'createStartDate', 'createEndDate')
					"
					type="datetimerange"
					range-separator="至"
					start-placeholder="开始日期"
					end-placeholder="结束日期"
					:default-time="['00:00:00', '23:59:59']"
					:default-value="timeDefaultShow"
					:picker-options="{
						disabledDate(time) {
							return time.getTime() > Date.now();
						},
					}"
				>
				</el-date-picker>
			</div>
			<el-button v-auth="'sa_order_page'" type="primary" @click="toSearch"
				>查询</el-button
			>
			<el-button
				v-auth="'sa_order_page'"
				type="primary"
				@click="() => ($root.showPage = false)"
				>重置</el-button
			>
			<el-button
				v-auth="'sa_order_export'"
				type="warning"
				@click="toExport"
				>导出数据</el-button
			>
		</div>
		<div class="cont-x" ref="tableBox">
			<div class="table-x">
				<el-table
					v-loading="loading"
					:height="tableHeight"
					:data="tableData"
					border
					class="mb20"
				>
					<el-table-column
						prop="orderNo"
						align="center"
						label="服务类别"
					>
						<template slot-scope="scope">
							{{ scope.row.serviceTypeName }}
						</template>
					</el-table-column>
					<el-table-column
						prop="itemName"
						align="center"
						label="服务项目"
					>
					</el-table-column>
					<el-table-column
						prop="serviceProvider"
						show-overflow-tooltip
						align="center"
						label="服务提供方"
					>
						<!-- <template slot-scope="scope">
                            {{ scope.row.serviceProvider.split(",").length }}
                            <el-tooltip placement="top" effect="light">
                                <div slot="content">{{ scope.row.serviceProvider }}</div>
                                <i class="el-icon-search"></i>
                            </el-tooltip>
                        </template> -->
					</el-table-column>
					<el-table-column
						prop="serviceCoverCount"
						align="center"
						label="服务覆盖人数"
					>
					</el-table-column>
					<el-table-column
						prop="serviceCoverPercent"
						align="center"
						label="服务覆盖人数占比（%）"
					>
						<template slot-scope="scope">
							{{
								scope.row.serviceCoverPercent
									? scope.row.serviceCoverPercent * 100 + "%"
									: ""
							}}
						</template>
					</el-table-column>
					<el-table-column
						prop="serviceUseCount"
						align="center"
						label="服务使用人次"
					>
					</el-table-column>
					<el-table-column
						prop="serviceCost"
						align="center"
						label="服务费支出（元）"
					>
					</el-table-column>
					<el-table-column
						prop="serviceModeName"
						show-overflow-tooltip
						align="center"
						label="服务提供方式"
					>
						<!-- <template slot-scope="scope">
                            {{ scope.row.serviceModeName.split(",").length }}
                            <el-tooltip placement="top" effect="light">
                                <div slot="content">{{ scope.row.serviceModeName }}</div>
                                <i class="el-icon-search"></i>
                            </el-tooltip>
                        </template> -->
					</el-table-column>
					<el-table-column
						prop="insuranceProductCategories"
						align="center"
						label="健康保险产品类别"
					>
					</el-table-column>
				</el-table>
			</div>
		</div>
		<div class="pagenation-x">
			<div class="pagination mb20">
				<el-pagination
					@current-change="handleCurrentChange"
					@size-change="handleSizeChange"
					:page-sizes="[10, 50, 100]"
					:current-page="searchBox.pageNo"
					:page-size="searchBox.pageSize"
					layout="total, sizes, prev, pager, next, jumper"
					:total="total"
					background
				>
				</el-pagination>
			</div>
		</div>
	</el-container>
</template>

<script>
	import getService from "@/mixins/getService.mixin";
	import { dateFormat, dataArrFormat } from "@/assets/js/until.js";

	// 带全选功能的下拉框
	import SelectAll from "@/components/SelectAll";
	export default {
		name: "Supervise",
		mixins: [getService],
		components: {
			SelectAll,
		},
		data() {
			return {
				// table表格
				loading: false,
				tableData: [], // table数据
				total: 0,
				tableHeight: 0,
				timeDefaultShow: "",
				// 查询条件
				timeCache: [], // 时间缓存
				statusArr: [],
				serviceList: [], // 服务类型选择 list
				supplierList: [], // 供应商列表
				searchBox: {
					pageNo: 1, // 页码
					pageSize: 10,
				}, // 搜索条件
				optionsData: [], // 筛选项数据
			};
		},
		created() {
			// 面包导航
			this.$root.breadList = [
				{ name: "报表中心", link: "" },
				{ name: "监管报表", link: "" },
			];
			this.getDefaultTime();
		},
		mounted() {
			this.dataTime();
			this.getOptions();
			this.getServiceList();
			this.getSupplierList();
			this.getData();
			this.$nextTick(() => {
				this.listenWindow();
			});
		},
		filters: {
			/**
			 * 服务类型filter
			 */
			serviceTypeFilter(id, serviceTypeList) {
				if (!serviceTypeList?.length || !id) return "";
				let data;
				serviceTypeList.forEach((el) => {
					if (el.id == id) data = el;
					if (el?.children?.length) {
						el.children.forEach((e) => {
							if (e.id == id) data = e;
						});
					}
				});
				return data?.name;
			},
		},
		methods: {
			//窗口改变，重新取得高度
			listenWindow() {
				this.tableHeight = this.$refs.tableBox.offsetHeight;
				window.addEventListener("resize", () => {
					clearTimeout(this.resizeFlag);
					this.resizeFlag = setTimeout(() => {
						try {
							this.tableHeight = this.$refs.tableBox.offsetHeight;
						} catch (e) {}
					}, 500);
				});
			},
			// 设置日期选择默认为上月及当月
			dataTime() {
				this.timeDefaultShow = new Date();
				this.timeDefaultShow.setMonth(new Date().getMonth() - 1, 1);
			},
			/**
			 * 时间回调函数
			 */
			toChangeTime(val, startName, endName) {
				if (val && val.length) {
					this.searchBox[startName] = dateFormat(val[0]);
					this.searchBox[endName] = dateFormat(val[1]);
				} else {
					this.searchBox[startName] = "";
					this.searchBox[endName] = "";
				}
			},
			/**
			 * 搜索按钮
			 */
			toSearch() {
				this.searchBox.pageNo = 1;
				this.getData();
			},
			/**
			 * 导出数据
			 */
			toExport() {
				// 数据处理
				let param = {
					...this.searchBox,
				};
				delete param.pageNo;
				delete param.pageSize;
				Object.keys(param).forEach((key) => {
					if (
						Object.prototype.toString.call(param[key]) ===
						"[object Array]"
					) {
						param[key] =
							param[key].length == 1
								? param[key][0]
								: param[key].join(",");
					}
				});
				let urlPath = this.getApiUrl("superviseReportExport");
				this.$root.exportFile(urlPath, param, "监管报表导出");
			},
			/**
			 * 获取数据
			 */
			getData() {
				this.loading = true;
				let params = Object.assign({}, this.searchBox);
				Object.keys(params).forEach((key) => {
					if (
						Object.prototype.toString.call(params[key]) ===
						"[object Array]"
					) {
						params[key] =
							params[key].length == 1
								? params[key][0]
								: params[key].join(",");
					}
				});
				this.axios
					.get(this.getApiUrl("superviseReport"), {
						params,
					})
					.then((res) => {
						this.loading = false;
						if (res.code === 1) {
							this.tableData = res.data.data || [];
							this.total = res.data.total;
						} else {
							this.$message.warning(res.msg);
						}
					})
					.catch((err) => {
						this.loading = false;
					});
			},
			/**
			 * 换页
			 */
			handleCurrentChange(val) {
				this.searchBox.pageNo = val;
				this.getData();
			},
			handleSizeChange(val) {
				this.searchBox.pageNo = 1;
				this.searchBox.pageSize = val;
				this.getData();
			},
			/**
			 * 获取服务项目列表
			 */
			async getServiceList() {
				let res = await this.axios.get(this.getApiUrl("itemServicePage"), {
					params: {
						pageNo: 1,
						pageSize: 1000,
					},
				});
				this.serviceList = res?.data?.data || [];
			},
			/**
			 *  筛选项数据
			 */
			async getOptions() {
				// 接口请求
				const res = await this.axios.get(
					this.getApiUrl("cmsRightOptions"),
					{
						params: {},
					}
				);
				if (res.code === 1) {
					let optionDataArr = dataArrFormat(
						res.data.insuranceProductCategoryList
					);
					this.optionsData = optionDataArr || [];
				} else {
					this.$message.warning(res.msg);
				}
			},
			getDefaultTime() {
				let time = new Date();
				this.timeCache = [
					`${time.getFullYear()}-01-01 00:00:00`,
					`${time.getFullYear()}-${
						time.getMonth() + 1
					}-${time.getDate()} 23:59:59`,
				];
				this.searchBox["createStartDate"] = dateFormat(this.timeCache[0]);
				this.searchBox["createEndDate"] = dateFormat(this.timeCache[1]);
			},
		},
	};
</script>

<style lang="scss" scoped>
	.cont-x {
		flex: 1;
		flex-shrink: 0;
	}
</style>